import React from 'react';
import {AppGridLayout,AppTable,AppTableSearch,AppSearchItem,AppButton,AppRow} from 'qcc';

export default class extends React.Component {

	render() {
		return (
        <AppGridLayout>
            <AppGridLayout.SearchArea>
                <AppTableSearch>
                    <AppTableSearch.Common>
                        <AppSearchItem.SearchInput placeholder='请录入模块名称' keyName='common' field='module_name'/>
                    </AppTableSearch.Common>
                </AppTableSearch>
            </AppGridLayout.SearchArea>
            <AppGridLayout.GridArea>
                <AppTable paging sqlId='sql.audit.logGrid' orderBy='create_time desc,id'>
                    <AppTable.ColIndex />
                    <AppTable.Col title='操作人' field='user_name' />
                    <AppTable.Col title='ip' field='ip' />
                    <AppTable.ColDateTime title='时间' field='create_time' />
                    <AppTable.Col title='系统' field='system_name' />
                    <AppTable.Col title='模块' field='module_name' />
                    <AppTable.Col title='功能' field='action_name' />
                </AppTable>
            </AppGridLayout.GridArea>
        </AppGridLayout>)
	}
}


// WEBPACK FOOTER //
// ./src/page/application/audit/IndexGrid.tsx